import SharedRadioInput from '../shared/RadioInput';

import {
  addMissingMandatoryField,
  removeMissingMandatoryField,
  addRemark,
  removeRemark,
  updateRemark,
  addFile,
  removeFile,
} from 'reducers/homePersonalFormReducer';

import type { MessageProps } from '../shared/Message/Message.types';

interface HomeRadioInputProps {
  section: number;
  label: string;
  options: Array<{ value: string; label: string }>;
  value?: string;
  onChange?: (value: string) => void;
  message?: Omit<MessageProps, 'section'> & { section?: number };
  required?: boolean;
  infoText?: string;
  stacked?: boolean;
  disabled?: boolean;
  subLabel?: string;
  [x: string]: any;
}

const HomeRadioInput = (props: HomeRadioInputProps) => {
  const formActions = {
    addMissingMandatoryField,
    removeMissingMandatoryField,
    addRemark,
    removeRemark,
    updateRemark,
    addFile,
    removeFile,
  };

  return (
    <SharedRadioInput
      {...props}
      formStateKey="homePersonalForm"
      formActions={formActions}
    />
  );
};

export default HomeRadioInput;
